import { ReactNode } from 'react';
import { Text } from '@chakra-ui/react';
import { extra } from '@/theme/colors/palettes';

const WeeklyReportAssignmentBadge = ({
  children,
  isComplete = false,
  color,
}: {
  children: ReactNode;
  isComplete?: boolean;
  color?: string;
}) => (
  <Text
    role="status"
    variant={'urbanistExtraBold'}
    borderRadius="full"
    bg={extra.white}
    color={color ?? (isComplete ? extra.teal : extra.red)}
    fontSize="12px"
    lineHeight={'14px'}
    px={2}
    py={1}
    height={'22px'}
    boxShadow={`0px 2px 4px 0px ${extra.mediumBlue5pct}`}
  >
    {children}
  </Text>
);

export default WeeklyReportAssignmentBadge;
